import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-[auto,1fr] gap-4 py-2 group"
}
const _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass([
              'bg-sea-1 mb-0 self-center row-span-full rounded-full mx-auto overflow-hidden w-10 h-10 text-center items-center justify-center flex',
            ])
}
const _hoisted_4 = {
  key: 0,
  class: "fas fa-user text-lg text-white"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-darkGray-1 sm:pr-8" }
const _hoisted_7 = { class: "font-semibold text-gray-900" }
const _hoisted_8 = { class: "px-2 bg-gray-3 group-hover:bg-white rounded-md text-base font-normal" }
const _hoisted_9 = { class: "hidden text-sm sm:block" }
const _hoisted_10 = { class: "hidden text-sm sm:block" }
const _hoisted_11 = {
  key: 1,
  class: "grid grid-cols-[auto,1fr] gap-4 py-2 group"
}
const _hoisted_12 = { class: "text-darkGray-2 sm:pr-8 flex flex-col gap-1" }
const _hoisted_13 = { class: "font-semibold text-gray-900" }
const _hoisted_14 = { class: "px-2 bg-gray-3 group-hover:bg-white rounded-md text-base font-normal" }
const _hoisted_15 = { class: "flex gap-2" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = {
  key: 0,
  class: "absolute right-2 -top-1"
}

import { computed, ref, onMounted } from "vue";
import store from "@/store";
import router from "@/router";
import moment from "moment";
import { MagnifyingGlassIcon } from "@heroicons/vue/20/solid";


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralSearch',
  setup(__props) {

const inputRef = ref(null);

const isLoaded = ref(false);
const searchPending = ref(false);

onMounted(async () => {
  isLoaded.value = true;
});

function selectItemEventHandler(e: any) {
  if (e.identifier === "applicantpositionresponse") {
    const url =
      "/admin/positions/" + e.data.positionId + "/applicants/" + e.data.id;
    router.push(url);
  } else if (e.identifier === "positionresponse") {
    const url = "/admin/positions/" + e.data.id;
    router.push(url);
  }
}

const today = moment();
const todayInUnix = today.unix();

const isUnixDateBeforeToday = (unixDate: number) => {
  return unixDate < todayInUnix;
};

const isUnixDateAfterToday = (unixDate: number) => {
  return unixDate > todayInUnix;
};

async function onInputEventHandler(e: any) {
  if ((e.input as string).length > 2) {
    searchPending.value = true;
    await store.dispatch("search", e.input);
    searchPending.value = false;
  }
}

const computedSearchResult = computed(() => {
  // returns unique search result based on id
  const uniqueItems = new Map();
  store.getters.searchResult.forEach((item: any) => {
    uniqueItems.set(item.data.id, item);
  });
  return Array.from(uniqueItems.values());
});

function itemProjectionFunction(item: any) {
  if (item.identifier === "applicantpositionresponse") {
    return [
      item?.data?.user?.email,
      item?.data?.info?.firstname,
      item?.data?.info?.lastname,
      item?.data?.info?.ssn,
      item?.data?.info?.city,
      item?.data?.info?.zipCode,
      item?.data?.id?.toString(),
    ].join(" ");
  } else {
    return item?.data?.name + " " + item?.data?.id;
  }
}
function onBlurEventHandler() {
  inputRef.value.clearInput();
}

return (_ctx: any,_cache: any) => {
  const _component_vue3_simple_typeahead = _resolveComponent("vue3-simple-typeahead")!

  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(MagnifyingGlassIcon), {
          class: "pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-500",
          "aria-hidden": "true"
        }),
        _createVNode(_component_vue3_simple_typeahead, {
          id: "typeahead_id",
          class: "block h-full w-full border-0 bg-transparent py-0 pl-8 pr-0 text-gray-500 focus:ring-0 sm:text-sm",
          placeholder: "Sök...",
          items: computedSearchResult.value,
          minInputLength: 3,
          itemProjection: itemProjectionFunction,
          onOnInput: onInputEventHandler,
          onOnBlur: onBlurEventHandler,
          onSelectItem: selectItemEventHandler,
          ref_key: "inputRef",
          ref: inputRef
        }, {
          "list-item-text": _withCtx((slot) => [
            (slot.item?.identifier === 'applicantpositionresponse')
              ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (!slot.item?.data?.avatar)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: slot.item?.data?.avatar
                        }, null, 8, _hoisted_5))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h5", _hoisted_7, [
                      _createTextVNode(_toDisplayString(slot.item?.data?.info?.firstname) + " " + _toDisplayString(slot.item?.data?.info?.lastname) + " ", 1),
                      _createElementVNode("span", _hoisted_8, " #" + _toDisplayString(slot.item?.data?.id), 1)
                    ]),
                    _createElementVNode("p", _hoisted_9, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-envelope mr-2 text-azure-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(slot.item?.data?.user?.email), 1)
                    ]),
                    _createElementVNode("p", _hoisted_10, [
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "text-blue-1 fa-solid fa-location-crosshairs mr-2" }, null, -1)),
                      _createTextVNode(_toDisplayString(slot.item?.data?.position?.name), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("a", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", {
                    class: _normalizeClass([
              'bg-purple-1 mb-0 self-center row-span-full rounded-full mx-auto overflow-hidden w-10 h-10 text-center items-center justify-center flex',
            ])
                  }, [
                    _createElementVNode("i", { class: "fa-solid fa-location-crosshairs text-lg text-white" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h5", _hoisted_13, [
                      _createTextVNode(_toDisplayString(slot.item?.data?.name) + " ", 1),
                      _createElementVNode("span", _hoisted_14, " #" + _toDisplayString(slot.item?.data?.id), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                  'text-white uppercase py-1 px-2 rounded-lg text-sm w-fit h-fit',
                  isUnixDateBeforeToday(slot.item?.data?.stop) ||
                  isUnixDateAfterToday(slot.item?.data?.start)
                    ? 'bg-red-2'
                    : 'bg-blue-1',
                ])
                      }, _toDisplayString(isUnixDateBeforeToday(slot.item?.data?.stop) ||
                  isUnixDateAfterToday(slot.item?.data?.start)
                    ? "Stängd"
                    : "Öppen"), 3),
                      _createElementVNode("div", {
                        title: `${slot.item?.data?.totalApplicants} person(er) har ansökt`,
                        class: _normalizeClass([
                  'bg-gray-3 group-hover:bg-white flex row-wrap gap-2 py-1 px-2 items-center rounded-lg text-xs w-fit h-fit',
                  slot.item?.data?.totalApplicants > 0
                    ? 'text-purple-1 '
                    : 'text-darkGray-4 ',
                ])
                      }, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-users" }, null, -1)),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(slot.item?.data?.totalApplicants), 1)
                      ], 10, _hoisted_16),
                      _createElementVNode("div", {
                        title: `${slot.item?.data?.totalUnProcessed} ansökning(ar) behöver hanteras`,
                        class: _normalizeClass([
                  'bg-gray-3 group-hover:bg-white flex row-wrap gap-2 py-1 px-2 items-center rounded-lg text-xs w-fit h-fit',
                  slot.item?.data?.totalUnProcessed > 0
                    ? 'text-azure-1'
                    : 'text-darkGray-4',
                ])
                      }, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-hourglass" }, null, -1)),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(slot.item?.data?.totalUnProcessed), 1)
                      ], 10, _hoisted_18)
                    ])
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["items"]),
        (searchPending.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fas fa-circle-notch fa-spin text-blue-1 group-hover:hidden" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})